// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import {
   OneTimeHeaderRow,
   HRImpProductRow,
   HRImpTypeRow,
   PayrollImpProductRow,
   TotalOneTimeRow,
   BenefitsAdministrationImpProductRow,
   BenAdminImpTypeRow,
   PayrollImpTypeRow,
   CoreCountryCountRow,
   AccountBalanceRow,
   TimeClocksRow,
   ProfessionalServicesRow,
   ProfessionalServicesTable,
   ConsultingServicesRow,
   ConsultingServicesTable,
   DynamicOneTimeProductRows,
} from '../rows/onetime'
import { QuoteAccordion, HorizontalRule } from '../ui-helper-elements'
// JS Imports
// Asset Imports

export default function OneTimeSection() {
   const state = useQuoteContext()
   const displaySectionPermissions =
      state.featurePermissions['OneTimeProductTable']

   if (!displaySectionPermissions.includes(state.user_role)) return null

   if (
      state.user_view == 'Internal' ||
      state.hrImplementationCosts.totalPrice +
         state.payrollImplementationTotalCosts.totalPrice >
         0
   ) {
      if (state.user_view == 'External') {
         return (
            <QuoteAccordion
               accordionName='One Time'
               accordionBodyId='onetimeAccordion'
               collapse={state.user_view == 'External' ? 'true' : 'false'}
            >
               <OneTimeHeaderRow />
               {/* <HRImpProductRow />
                    <HRImpTypeRow />
                    <PayrollImpProductRow />*/}
               <CoreCountryCountRow />
               <DynamicOneTimeProductRows />
               <TotalOneTimeRow />
               <AccountBalanceRow />
               <TimeClocksRow />
            </QuoteAccordion>
         )
      } else {
         return (
            <div>
               <HorizontalRule />
               <OneTimeHeaderRow />
               <HRImpProductRow />
               <HRImpTypeRow />
               <CoreCountryCountRow />
               <BenefitsAdministrationImpProductRow />
               <BenAdminImpTypeRow />
               <PayrollImpProductRow />
               <PayrollImpTypeRow />
               <DynamicOneTimeProductRows />
               <TotalOneTimeRow />
               <AccountBalanceRow />
               <TimeClocksRow />
               <ConsultingServicesRow />
               <ConsultingServicesTable />
               <ProfessionalServicesRow />
               <ProfessionalServicesTable />
            </div>
         )
      }
   }
   return null
}
